export default function TikTokIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.2961 2.50667C11.6886 1.81291 11.3537 0.922133 11.3538 0H8.60717V11.0222C8.58643 11.6188 8.33474 12.1841 7.90522 12.5987C7.4757 13.0133 6.90192 13.2448 6.30495 13.2444C5.04273 13.2444 3.99384 12.2133 3.99384 10.9333C3.99384 9.40444 5.46939 8.25778 6.98939 8.72889V5.92C3.92273 5.51111 1.23828 7.89333 1.23828 10.9333C1.23828 13.8933 3.69162 16 6.29606 16C9.08717 16 11.3538 13.7333 11.3538 10.9333V5.34222C12.4676 6.14209 13.8048 6.57124 15.1761 6.56889V3.82222C15.1761 3.82222 13.5049 3.90222 12.2961 2.50667Z"
        fill="#0A1B2F"
      />
    </svg>
  );
}
